import { render } from "./MarketingView.vue?vue&type=template&id=454ed41d"
import script from "./MarketingView.vue?vue&type=script&lang=js"
export * from "./MarketingView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__